













import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class GridItemContent extends Vue {
    private title: string = '';
    private subtitle: string = '';
    private body: string[][] = [];
    private id: number = -1;
    private sortIndex: number = -1;
    private icon: string = '';
    private images: string[] = [];
    private bgColor: string = 'rgb(111, 111, 111)';
    private titleColor: string = '';
    private filter: string = '';


    get cTitle() {
        return this.title;
    }

    set cTitle(newTitle: string) {
        this.title = newTitle;
    }

    get cSubtitle() {
        return this.subtitle;
    }

    set cSubtitle(newSubtitle: string) {
        this.subtitle = newSubtitle;
    }

    get cBody() {
        return this.body;
    }

    set cBody(newBody: string[][]) {
        this.body = newBody.filter((answer) => answer !== null);

        if (this.body.some(Boolean)) {
            this.titleColor = '#002C7C';
            // this.bgColor = "#006AFB";
        } else {
            this.titleColor = 'rgb(111, 111, 111)';
        }
    }

    get cId() {
        return this.id;
    }

    set cId(newId: number) {
        this.id = newId;
    }

    get cIcon() {
        return this.icon;
    }

    set cIcon(newIcon: string) {
        this.icon = newIcon;
    }

    get cSortIndex() {
        return this.sortIndex;
    }

    set cSortIndex(newSortIndex: number) {
        this.sortIndex = newSortIndex;
    }

    get cImages() {
        return this.images;
    }

    set cImages(newImages: string[]) {
        this.images = newImages;
    }

    get cBgColor() {
        return this.bgColor;
    }

    set cBgColor(newColor: string) {
        this.bgColor = newColor;
    }

    get cFilter() {
        return this.filter;
    }

    set cFilter(newFilter: string) {
        this.filter = newFilter;
    }
}
